import React from "react"
import BoardImage from "../images/board.jpg"
export default function LandingAboutUs() {
  return (
    <div className="bg-white">
      <div className="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
        <div className="text-center">
          <p class=" text-5xl md:text-7xl font-extrabold  text-blue-500 ">
            Innovation in cyber security{" "}
          </p>
          <div className=" flex flex-row flex-wrap">
            {" "}
            <p className="max-w-xl mt-5 mx-auto text-xl text-gray-500">
              Foundation CR14 was established by the Estonian Ministry of
              Defence on the 1st of January 2021 and is based on more than 10
              years of military-grade cyber range experience in cybersecurity
              training, exercises, testing, validation and experimentation. CR14
              is a government-owned and operated entity, which offers
              cybersecurity-related research and development for domestic and
              international; private and public sector partners.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
